import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";

import "../styles/home.scss";
import { API_URL } from "../constant";
import { App } from "../firebase";
import Adresse from "../components/address";

const Prestataires = () => {
  const { id } = useParams();
  const history = useHistory();
  const [prestataire, setPrestataires] = useState(history.location.state);
  const [prestations, setPrestations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = React.useState([]);

  const isItemSelected = (id) => !!selected.find((el) => el === id);
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours > 0) {
      return rhours + "h " + rminutes + " min.";
    } else {
      return num + " min.";
    }
  }
  const handleClick =
    (id) =>
    ({ getItemById, scrollToItem }) => {
      const itemSelected = isItemSelected(id);

      setSelected((currentSelected) =>
        itemSelected
          ? currentSelected.filter((el) => el !== id)
          : currentSelected.concat(id)
      );
    };
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function loadPrestation() {
    setLoading(true);
    // console.log("prestataire", prestataire, id);
    fetch(API_URL + "prestations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        prestataire: prestataire == undefined,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          if (prestataire == undefined) setPrestataires(data.prestataire);
          setPrestations(data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  useEffect(() => {
    loadPrestation();
  }, []);

  const Hero = () => {
    function Card({ onClick, selected, index, itemId }) {
      const visibility = React.useContext(VisibilityContext);

      return (
        <div onClick={() => onClick(visibility)} tabIndex={0}>
          <div
            className="bloc-photo"
            style={{
              backgroundImage: `url("` + index + `")`,

              marginRight:
                itemId ===
                  prestataire.pictures[prestataire.pictures.length - 1] && 30,
            }}
          />
        </div>
      );
    }
    function ccal() {
      return (size.width - size.width * 0.76) / 2;
    }

    return (
      <>
        <div
          style={{
            marginTop: size.width <= 428 ? 10 : 50,
            maxWidth: size.width,
          }}
        >
          <ScrollMenu>
            <div
              style={{
                backgroundColor: "white",
                width: size.width <= 428 ? 36 : ccal(),
                height: 100,
              }}
            />
            {prestataire ? (
              prestataire.pictures.map((id) => (
                <Card
                  itemId={id} // NOTE: itemId is required for track items
                  index={id}
                  key={id}
                  onClick={handleClick(id)}
                  selected={isItemSelected(id)}
                />
              ))
            ) : (
              <div style={{ width: "100vw" }}>
                <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
                  <div class="loader" />
                </div>
              </div>
            )}
          </ScrollMenu>
        </div>
      </>
    );
  };

  const Presta = ({ data }) => {
    const [detail, setDetail] = useState(false);
    const [user, setUser] = useState(null);
    useEffect(() => {
      App.auth().onAuthStateChanged((u) => {
        if (u) {
          setUser(u);
        } else {
          setUser(null);
        }
      });
    }, []);

    const addPres = (v = false) => {
      setTimeout(() => {
        if (user) {
          // if (!user.emailVerified) {
          //   if (
          //     // eslint-disable-next-line no-restricted-globals
          //     confirm("Pour continuez veuillez vérifié votre compte par email.")
          //   ) {
          //     history.push("/mon-compte/");
          //   }
          // } else {
          let res = prestataire;
          res.prestations = prestations;

          history.push({
            pathname: "/prise-de-rendez-vous/" + data.id,
            state: res,
          });
          // }
        } else {
          if (v) {
            // eslint-disable-next-line no-restricted-globals
            if (confirm("Connexion nécessaire")) {
              history.push("/mon-compte/#selectprestation");
            }
          } else {
            setUser(App.auth().currentUser);
            setTimeout(() => {
              addPres(true);
            }, 100);
          }
        }
      }, 200);
    };
    return (
      <>
        <div
          style={{
            padding: "20px 30px ",
            display: size.width > 428 && "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p className="raleway-semi-bold-black-18px">{data.name}</p>
            <p
              className="roboto-normal-16px"
              style={{ padding: "8px 0px", paddingRight: 10 }}
            >
              {data.description}
            </p>
            <p
              className="raleway-bold-silver-12px "
              onClick={() => {
                setDetail(!detail);
              }}
            >
              {detail
                ? data.note
                  ? data.note
                  : "Aucun détail pour la prestation"
                : "Plus de détails"}
            </p>
          </div>
          <div
            style={{
              margin: "auto",
              marginRight: 0,
              display: size.width > 428 && "flex",
            }}
          >
            <div
              style={{
                display: size.width <= 428 && "flex",
                marginTop: size.width <= 428 && 10,
              }}
            >
              <p
                className="raleway-bold-black-18px"
                style={{
                  textAlign: "end",
                  paddingBottom: size.width <= 428 ? 30 : 5,
                  marginRight: size.width <= 428 && 30,
                }}
              >
                {data.price ? `${(data.price / 100).toFixed(2)}€` : "Sur devis"}
              </p>
              <p className="raleway-light-silver-18px">
                {data.price ? timeConvert(data.time) : ""}
              </p>
            </div>
            <a
              onClick={data.price && addPres}
              style={{ textDecoration: "none" }}
              href={
                data.price === null &&
                (prestataire.phone ? `tel:${prestataire.phone}` : null)
              }
            >
              <div
                class=" border-2px-eerie-black"
                style={{
                  cursor: "pointer",
                  borderRadius: 10,
                  display: "flex",
                  height: 34,
                  width: data.price
                    ? 68
                    : prestataire.phone
                    ? 100
                    : size.width > 428
                    ? 320
                    : null,
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: size.width > 428 && 49,
                }}
              >
                <div class="sinscrire raleway-bold-eerie-black-12px">
                  {data.price
                    ? "Choisir"
                    : prestataire.phone
                    ? prestataire.phone
                    : "Le professionnel n'a pas communiqué de téléphone"}
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="divider" />
      </>
    );
  };

  return (
    <>
      <div class="row" style={{ margin: "0px auto" }}>
        <Hero />
      </div>
      <div
        class="row"
        style={{ maxWidth: size.width > 428 && "76%", margin: "0px auto" }}
      >
        <div
          class="col-75"
          style={{
            marginLeft: size.width <= 428 && 20,
            marginRight: size.width <= 428 && 20,
            padding: 0,
            marginBottom: 30,
          }}
        >
          {prestataire && (
            <div
              class={size.width < 1536 && "container"}
              style={{ padding: size.width <= 428 ? 16 : 0 }}
            >
              {size.width <= 428 ? (
                <h1
                  className=" raleway-extra-bold-eerie-black-50px"
                  style={{
                    paddingBottom: 10,
                    fontSize: size.width <= 428 ? "16px" : "35px",
                    marginTop: size.width <= 428 ? 0 : 50,
                    // top: size.width <= 428 && "0px!important",
                  }}
                >
                  Réservez votre rendez-vous en
                  <br />
                  ligne chez {prestataire && prestataire.name}
                </h1>
              ) : (
                <h1
                  className="rservez-vos-rendez-2 raleway-extra-bold-eerie-black-50px"
                  style={{
                    paddingBottom: 10,
                    fontSize: size.width <= 428 ? "16px" : "35px",
                    marginTop: size.width <= 428 ? 0 : 50,
                    // top: size.width <= 428 && "0px!important",
                  }}
                >
                  Réservez votre rendez-vous en
                  <br />
                  ligne chez {prestataire && prestataire.name}
                </h1>
              )}

              <p
                class="address subtitle raleway-medium-dove-17px "
                style={{ paddingBottom: 61 }}
              >
                {prestataire.adresse +
                  " " +
                  prestataire.zipcode +
                  " " +
                  prestataire.city}
              </p>
              {loading ? (
                <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
                  <div class="loader" />
                </div>
              ) : (
                <>
                  {prestataire.holidayMode || !prestataire.isActif ? (
                    <Adresse
                      address={
                        "Le prestataire est actuellement " +
                        (!prestataire.isActif ? "indisponible." : "en vacance.")
                      }
                    />
                  ) : (
                    <>
                      {prestataire ? (
                        <>
                          {Object.keys(prestations).map((keyName) => (
                            <>
                              <p className="raleway-bold-black-22px">
                                {keyName}
                              </p>
                              {prestations[keyName] && (
                                <div
                                  className="col-75 bloc-rdv"
                                  style={{ padding: 0, marginBottom: 60 }}
                                >
                                  {" "}
                                  <div
                                    className="content-sha content-rdv"
                                    style={{ borderRadius: 30 }}
                                  >
                                    {prestations[keyName]
                                      .sort(
                                        (a, b) => (a.rank || 0) - (b.rank || 0)
                                      )
                                      .map((e) => (
                                        <Presta data={e} />
                                      ))}
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </>
                      ) : (
                        <p className="content-p " style={{ marginBottom: 100 }}>
                          Aucune prestations disponible.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Prestataires;
